export const deepFind = (obj: object, path: string): object | undefined => {
    let current = obj;
    path?.split('.')
        .forEach(s => {
            current = current[s as keyof typeof current];
        });

    return current;
};

export const invoke = (obj: object, path: string, ...args: Array<object>) => {
    const func = deepFind(obj, path);
    if (typeof func === 'function') {
        return func.apply(obj, args);
    }

    return undefined;
};
